import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   max-width: 480px;
   width: 100%;

   .section {
      margin-bottom: 16px;
   }

   .label {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
      display: block;
   }

   .helper-text {
      font-size: 12px;
      color: #666;
      margin-bottom: 6px;
   }

   .input-field {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #ddd;
      border-radius: 6px;
      background: #fff;
      color: #333;
      font-size: 14px;
      font-family: inherit;
      transition: all 0.2s;

      &:focus {
         outline: none;
         border-color: #25D366;
         box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
      }

      &::placeholder {
         color: #999;
      }
   }

   .textarea-field {
      width: 100%;
      padding: 10px 12px;
      border: 1px solid #ddd;
      border-radius: 6px;
      background: #fff;
      color: #333;
      font-size: 14px;
      font-family: inherit;
      resize: vertical;
      min-height: 100px;
      transition: all 0.2s;

      &:focus {
         outline: none;
         border-color: #25D366;
         box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
      }

      &::placeholder {
         color: #999;
      }
   }

   .tip {
      font-size: 11px;
      color: #999;
      display: flex;
      align-items: center;
      gap: 4px;
      margin-top: 4px;

      code {
         background: #e0e7ff;
         padding: 2px 6px;
         border-radius: 3px;
         font-family: 'Courier New', monospace;
         color: #3730a3;
      }
   }

   .variables-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 12px;
      background: #f9f9f9;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
   }

   .variable-chip {
      background: #e0e7ff;
      color: #3730a3;
      padding: 6px 12px;
      border-radius: 16px;
      font-size: 12px;
      font-family: 'Courier New', monospace;
      font-weight: 500;
      border: 1px solid #c7d2fe;
   }

   .status-box {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px;
      border-radius: 6px;
      font-size: 14px;

      &.success {
         background: rgba(16, 185, 129, 0.1);
         border: 1px solid rgba(16, 185, 129, 0.3);
         color: #10b981;
      }

      &.error {
         background: rgba(239, 68, 68, 0.1);
         border: 1px solid rgba(239, 68, 68, 0.3);
         color: #ef4444;
      }

      svg {
         font-size: 20px;
      }
   }

   .warning-box {
      display: flex;
      gap: 12px;
      padding: 16px;
      background: rgba(251, 191, 36, 0.1);
      border: 1px solid rgba(251, 191, 36, 0.3);
      border-radius: 8px;
      margin-bottom: 8px;
   }

   .warning-icon {
      font-size: 24px;
      flex-shrink: 0;
      color: #f59e0b;
   }

   .warning-text {
      flex: 1;

      strong {
         display: block;
         color: #f59e0b;
         font-size: 14px;
         margin-bottom: 6px;
      }

      p {
         margin: 0;
         font-size: 12px;
         color: #666;
         line-height: 1.5;
      }
   }
`;